import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgMap } from "../../utils/dashboardUtils";
import DoubleMetricCard from "../metrics/DoubleMetricCard";
import MetricCard from "../metrics/MetricCard";

const LivabilityMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("Livability data:", sortedMetrics);

    if (!indicators || indicators.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const l: DisaggregatedMetric[] = sortedMetrics[0];
    const shareIncomeM = indicators?.find(i => i.id === 1209);
    const shareIncomeR = indicators?.find(i => i.id === 1210);

    const burdenedR = indicators?.find(i => i.id === 1212);
    const burdenedH = indicators?.find(i => i.id === 1213);

    return (
        <>
            <div className="flex flex-col gap-4">
                <div className="flex justify-center">
                    {shareIncomeM && shareIncomeR && (
                    <DoubleMetricCard 
                        key={1209}
                        metricOne={shareIncomeM}
                        metricTwo={shareIncomeR}
                        subtextOne="Rent"
                        subtextTwo="Mortgage"
                        title="Share of Income Spent"
                        metadataId={1232}
                        width="w-full"
                        svg={getSvgMap(1209)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                    )}
                </div>

                <div className="flex justify-around items-end flex-wrap">
                    {burdenedR && burdenedH && (
                    <DoubleMetricCard 
                        key={1211}
                        metricOne={burdenedR}
                        metricTwo={burdenedH}
                        subtextOne="Renters"
                        subtextTwo="Owners"
                        title="Housing Cost Burden"
                        metadataId={1211}
                        width="w-full"
                        svg={getSvgMap(1211)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                    )}
                    {l?.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}
                </div>
                
                
            </div>
        </>
    );
}

export default LivabilityMetrics;